import { queryOptions, keepPreviousData } from '@tanstack/react-query'
import { getTicketDetail, listMyTickets, resolveWidgetUser, trackTicket, getCategories, listProjectTags } from '../api-client'

export const widgetTicketDetailOptions = (ticketId: string) =>
  queryOptions({
    queryKey: ['widget-ticket', ticketId],
    queryFn: () => getTicketDetail(ticketId),
    staleTime: 60_000,
    enabled: !!ticketId,
  })

export const widgetMyTicketsOptions = (projectId: string, userId: string, showAll = false) =>
  queryOptions({
    queryKey: ['widget-tickets', projectId, userId, showAll],
    queryFn: () => listMyTickets(projectId, userId, 1, 20, showAll),
    staleTime: 30_000,
    placeholderData: keepPreviousData,
    enabled: showAll || !!userId,
  })

export const widgetUserOptions = (projectId: string, email: string) =>
  queryOptions({
    queryKey: ['widget-user', projectId, email],
    queryFn: () => resolveWidgetUser(projectId, email),
    staleTime: 5 * 60_000,
    enabled: !!email,
    // First-time users legitimately 404 on this probe (the widget user row is created on the
    // first ticket submission) — suppress the global toast so the widget doesn't yell at every
    // fresh visitor just for opening the form.
    meta: { allow404: true, silent: true },
  })

export const widgetTrackTicketOptions = (token: string) =>
  queryOptions({
    queryKey: ['widget-track', token],
    queryFn: () => trackTicket(token),
    staleTime: 60_000,
    enabled: !!token,
  })

export const widgetCategoriesOptions = (projectId: string, parentId?: string | null) =>
  queryOptions({
    queryKey: ['widget-categories', projectId, parentId ?? 'root'],
    queryFn: () => getCategories(projectId, parentId),
    staleTime: 5 * 60_000,
  })

export const widgetTagsOptions = (projectId: string) =>
  queryOptions({
    queryKey: ['widget-tags', projectId],
    queryFn: () => listProjectTags(projectId),
    staleTime: 5 * 60_000,
    enabled: !!projectId,
    // Tags are an optional/nice-to-have on the submit form — never page the user if the project
    // has no tags defined or the list endpoint is briefly unreachable.
    meta: { silent: true },
  })
